document.querySelectorAll('.DoubleBannerHalf').forEach((container) => {
    tns({
        container,
        items: 1,
        slideBy: 1,
        controls: false,
        nav: true,
        mouseDrag: true,
        center: false,
        gutter: 20,
        loop: true,
        responsive: {
            768: {
                items: 2,
                slideBy: 2,
            }
        }
    });
});
